import { graphQlClient } from '../utils/graphQlClient';
import { gql } from '@apollo/client';

const AGENT_AUTHENTICATE_QUERY = gql`
  query agentAuthenticate($input: AgentAuthenticateInput!) {
    agentAuthenticate(input: $input) {
      organization {
        cipherKey
        slug
      }
      config {
        publishKey
        subscribeKey
        origin
      }
      token
      incomeChannel
    }
  }
`;

interface AgentAuthenticateInput {
  id: string;
  organizationId: number;
}

export interface AgentAuthenticateResponse {
  organization: {
    cipherKey: string;
    slug: string;
  };
  config: {
    publishKey: string;
    subscribeKey: string;
    origin: string;
  };
  token: string;
  incomeChannel: string;
}

export const agentAuthenticate = async (
  input: AgentAuthenticateInput,
): Promise<AgentAuthenticateResponse> => {
  const gqlClient = graphQlClient.getClient();
  const { data } = await gqlClient.query<{ agentAuthenticate: AgentAuthenticateResponse }>({
    query: AGENT_AUTHENTICATE_QUERY,
    variables: { input },
    fetchPolicy: 'no-cache',
    context: {
      uri: '/prior-auth/api/graphql',
    },
  });

  return data.agentAuthenticate;
};
